export default "__VITE_ASSET__CGeye5H0__"